module.exports = __webpack_public_path__ + "img/bvkt.43ab70ce.png";